
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!feature_flags.feature_flag";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'feature-flags/featureFlag';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "true";
  }

function program3(depth0,data) {
  
  
  return "false";
  }

function program5(depth0,data) {
  
  
  return "down";
  }

function program7(depth0,data) {
  
  
  return "right";
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <span class=\"label label-";
  if (helper = helpers.cssClass) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.cssClass); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n    ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <div id=\"ff_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"ui-buttonset ui-buttonset--feature-settings ui-buttonset--feature-settings-responsive\">\n        <div class=\"ff-background ff-left ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableOff), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n          <input type=\"radio\" id=\"ff_off_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" name=\"ff_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"ff_button\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isOff), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableOff), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " data-id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-action=\"off\">\n          <label for=\"ff_off_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" role=\"button\" aria-label=\"Turn off ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" aria-disabled=\"";
  if (helper = helpers.disableOff) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.disableOff); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "off", "Off", options) : helperMissing.call(depth0, "t", "off", "Off", options)))
    + "\n          </label>\n        </div>\n        <div class=\"ff-background ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableAllow), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n          <input type=\"radio\" id=\"ff_allowed_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" name=\"ff_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"ff_button\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isAllowed), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableAllow), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " data-id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-action=\"allowed\">\n          <label for=\"ff_allowed_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" role=\"button\" aria-label=\"Allow ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" aria-disabled=\"";
  if (helper = helpers.disableAllow) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.disableAllow); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "allow", "Allow", options) : helperMissing.call(depth0, "t", "allow", "Allow", options)))
    + "\n          </label>\n        </div>\n        <div class=\"ff-background ff-right ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableOn), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n          <input type=\"radio\" id=\"ff_on_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" name=\"ff_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"ff_button\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isOn), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableOn), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " data-id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-action=\"on\">\n          <label for=\"ff_on_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" role=\"button\" aria-label=\"Turn on ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" aria-disabled=\"";
  if (helper = helpers.disableOn) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.disableOn); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "on", "On", options) : helperMissing.call(depth0, "t", "on", "On", options)))
    + "\n          </label>\n         </div>\n      </div>\n    ";
  return buffer;
  }
function program12(depth0,data) {
  
  
  return "ff-disabled";
  }

function program14(depth0,data) {
  
  
  return "checked";
  }

function program16(depth0,data) {
  
  
  return "disabled";
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <!-- start super toggle -->\n      <label class=\"ic-Super-toggle--on-off\" for=\"ff_toggle_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n        <span class=\"screenreader-only\">\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableToggle), {hash:{},inverse:self.program(24, program24, data),fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </span>\n        <input id=\"ff_toggle_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"ic-Super-toggle__input ff_toggle\" type=\"checkbox\"\n               ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isOn), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.disableToggle), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " data-id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n        <div class=\"ic-Super-toggle__container\" aria-hidden=\"true\" data-checked=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "on", "On", options) : helperMissing.call(depth0, "t", "on", "On", options)))
    + "\" data-unchecked=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "off", "Off", options) : helperMissing.call(depth0, "t", "off", "Off", options)))
    + "\">\n          <div class=\"ic-Super-toggle__switch\">\n            <div class=\"ic-Super-toggle__option--LEFT\">\n              <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" width=\"548.9\" height=\"548.9\"\n                   viewBox=\"0 0 548.9 548.9\" xml:space=\"preserve\">\n                <polygon points=\"449.3 48 195.5 301.8 99.5 205.9 0 305.4 95.9 401.4 195.5 500.9 295 401.4 548.9 147.5\" />\n              </svg>\n            </div>\n            <div class=\"ic-Super-toggle__option--RIGHT\">\n              <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 28 28\" xml:space=\"preserve\">\n                <polygon points=\"28 22.4 19.6 14 28 5.6 22.4 0 14 8.4 5.6 0 0 5.6 8.4 14 0 22.4 5.6 28 14 19.6 22.4 28\" />\n              </svg>\n            </div>\n          </div>\n        </div>\n      </label>\n      <!-- end super toggle -->\n    ";
  return buffer;
  }
function program19(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isOn), {hash:{},inverse:self.program(22, program22, data),fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }
function program20(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "title_is_on_2b72a9b7", "%{title} is on", options) : helperMissing.call(depth0, "t", "title_is_on_2b72a9b7", "%{title} is on", options)))
    + "\n            ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "title_is_off_6c823e2d", "%{title} is off", options) : helperMissing.call(depth0, "t", "title_is_off_6c823e2d", "%{title} is off", options)))
    + "\n            ";
  return buffer;
  }

function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "enable_feature_title_987d8e9a", "Enable feature: %{title}", options) : helperMissing.call(depth0, "t", "enable_feature_title_987d8e9a", "Enable feature: %{title}", options)))
    + "\n          ";
  return buffer;
  }

function program26(depth0,data) {
  
  
  return "block";
  }

function program28(depth0,data) {
  
  
  return "none";
  }

function program30(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "estimated_release", "Estimated Release:", options) : helperMissing.call(depth0, "t", "estimated_release", "Estimated Release:", options)))
    + "\n        <span class=\"feature-release-date\">\n          "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.releaseOn), "medium", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.releaseOn), "medium", options)))
    + "\n        </span>\n        </br>\n      ";
  return buffer;
  }

function program32(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        ";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }

function program34(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        ("
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "no_description", "no description", options) : helperMissing.call(depth0, "t", "no_description", "no description", options)))
    + ")\n      ";
  return buffer;
  }

function program36(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <a href=\"";
  if (helper = helpers.releaseNotesUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.releaseNotesUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"feature-release-notes-link\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "release_notes", "release notes", options) : helperMissing.call(depth0, "t", "release_notes", "release notes", options)))
    + "\n      </a>\n    ";
  return buffer;
  }

  buffer += "<div class=\"row-fluid feature ";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  <div class=\"span7\">\n    <span\n       class=\"element_toggler\"\n       aria-controls=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-details\"\n       aria-expanded=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isExpanded), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n       role=\"button\"\n       tabindex=\"0\">\n       <span class=\"screenreader-only\">\n         "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'scope': ("feature_flags.feature_flag")
  },data:data},helper ? helper.call(depth0, "toggle_feature_details_screenreader_info", "Toggle feature details for %{title}", options) : helperMissing.call(depth0, "t", "toggle_feature_details_screenreader_info", "Toggle feature details for %{title}", options)))
    + "\n       </span>\n       <i class=\"icon-mini-arrow-";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isExpanded), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"></i>\n    </span>\n    <span class=\"feature-title\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n\n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.labels), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n\n  <div class=\"span5 text-right span5-responsive\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.threeState), {hash:{},inverse:self.program(18, program18, data),fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n\n<div class=\"feature-details row-fluid\" id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-details\" style=\"display: ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isExpanded), {hash:{},inverse:self.program(28, program28, data),fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n  <div class=\"span10\">\n    <p class=\"feature-description\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.releaseOn), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.description), {hash:{},inverse:self.program(34, program34, data),fn:self.program(32, program32, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </p>\n  </div>\n\n  <div class=\"span2 text-right feature-detail-links\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.releaseNotesUrl), {hash:{},inverse:self.noop,fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  